<template>
	<div class="info-panel column main is-5">
		<div class="panel info-panel">
			<div class="panel-block title">
				{{ displayFPTitle(fireProtection) }} 
			</div>
			<div class="panel-block block">
				<p class="label">{{ $t('firepanel.type') }}</p>
				<div class="box">{{ displayFPName(fireProtection) }}</div>
			</div>
			<div class="panel-block block">
				<p class="label">{{ $t('firepanel.recommendation') }}</p>
				<div class="box">{{ fireProtection.recommendation }}</div>
			</div>
			<div class="panel-block block">
				<p class="label">{{ $t('firepanel.instruction') }}</p>
				<div class="box">{{ tInstruction(fireProtection.instruction) }}</div>
			</div>
			<div class="panel-block block">
				<p class="label">{{ $t('firepanel.description') }}</p>
				<div class="box">{{ tDescription(fireProtection.description) }}</div>
			</div>
		</div>
	</div>
</template>

<script>

import typeMixin from '@/mixins/iconMixin'; 
export default {
	mixins: [typeMixin],
	props: {
		fireProtection: Object
	}
};
</script>
